import React, { useEffect, useState } from 'react';
import Marquee from "react-fast-marquee";
import { Link } from "react-router-dom";
import io from "socket.io-client";
import './title.css'

const socket = io.connect("https://mayapurapp.ap-1.evennode.com");

const Title = () => {
  const [LiveBanner, setLiveBanner] = useState([]);

  useEffect(() => {
    socket.emit("retrieveAllAppData");
    socket.on("allAppDataRetrieved", (data) => {
      setLiveBanner(data);
    });
  }, []);

  const title = LiveBanner.slice(2, 3);

  return (
    <div className="w-full overflow-hidden" id="marquee-wrapper1">
      <Marquee
        direction="left"
        speed={55}
        delay={0}
        gradient={false}
      >
        {title?.map((item, index) =>
          item.title === "True" ? (
            <Link to="/tv" key={index}>
              <span className="text-white text-sm font-medium mr-8 ">
                {item?.url} ।
              </span>
            </Link>
          ) : null
        )}
      </Marquee>
    </div>
  );
};

export default Title;